'use client';

import { Link } from '@coolblue-development/freddy';
import selectBannerTrigger from '@coolblue-development/ga4-events/triggers/Banners/selectBannerTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useTranslation } from '@i18n/useTranslation';

type trackingParamsType = {
  sub_feature: 'top_fallback' | 'bottom_fallback' | 'top_paid' | 'bottom_paid';
  index: number;
  total_indices: number;
  url: string;
};

export function AdLink({
  href,
  children,
  isMobile,
  trackingParams
}: {
  href: string;
  children: React.ReactNode;
  isMobile: boolean;
  trackingParams: trackingParamsType;
}) {
  const { trackEvent } = useAnalytics();
  const { t } = useTranslation('webshop.filterPage.advertisement');

  if (!href) {
    return <>{children}</>;
  }

  return (
    <Link
      href={href}
      sx={{ alignSelf: 'flex-start', '& > div': isMobile ? {} : { alignItems: 'self-start' } }}
      onClick={() => trackEvent(selectBannerTrigger(trackingParams))}
      aria-label={t('linkText')}
    >
      {children}
    </Link>
  );
}
